import { InitCookie } from '@patsnap/init-cookie';

export class InitCookieService {
    getEntryChannel() {
        // const currentPath = window.location.pathname;
        return 'ip_home'
    }

    async init() {
        const entry_channel = this.getEntryChannel();
        if (entry_channel) {
            const cookie = new InitCookie({
                entry_channel,
            });
            return await cookie.init();
        }
    }
}

export const initCookieService = new InitCookieService();
